// src/components/apps/SharePointIT/SharePointITPage.jsx
import React, { useState } from "react";
import { Box, Typography, Paper, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SharePointITFileBrowser from "./SharePointITFileBrowser";
import SharePointITUploadDialog from "./SharePointITUploadDialog";
import { useAuth } from "../../../context/AuthContext";

const SharePointITPage = () => {
  const { isSso } = useAuth();
  const [refresh, setRefresh] = useState(false);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState(null);

  if (!isSso) {
    return (
      <Box sx={{ mt: 6, textAlign: "center" }}>
        <Typography variant="h5">
          SSO login is required to access IT Documents.
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          Please log in with your Microsoft account to access this feature.
        </Typography>
      </Box>
    );
  }

  const handleRefresh = () => setRefresh((prev) => !prev);

  return (
    <Box component="main" sx={{ mt: 4 }}>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          padding: 3,
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          marginTop: "50px",
          marginBottom: 4,
          textAlign: "center",
          transition: "transform 0.3s ease, boxShadow 0.3s ease",
          "&:hover": {
            transform: "translateY(-8px)",
            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Typography variant="h4" sx={{ mb: 2, color: "primary.main" }}>
          IT Document Library
        </Typography>

        <Paper sx={{ padding: 3, mb: 4, display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloudUploadIcon />}
            onClick={() => setUploadOpen(true)}
          >
            Upload File
          </Button>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={handleRefresh}
          >
            Refresh
          </Button>
        </Paper>

        <Paper sx={{ padding: 3, textAlign: "left" }}>
          <SharePointITFileBrowser
            refresh={refresh}
            onFolderChange={setCurrentFolderId}
          />
        </Paper>
      </Box>

      <SharePointITUploadDialog
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        parentFolderId={currentFolderId}
        onUploadComplete={handleRefresh}
      />
    </Box>
  );
};

export default SharePointITPage;
